import React, { useMemo } from 'react';
import TableContainer from '@mui/material/TableContainer';
import Table from '@mui/material/Table';
import { useQuery } from 'react-query';

import VpMediaTableHead from '@vp-ui/widgets/VpMediaTable/VpMediaTableHead';
import VpMediaTableBody from '@vp-ui/widgets/VpMediaTable/VpMediaTableBody';
import VpMediaTablePagination from '@vp-ui/widgets/VpMediaTable/VpMediaTablePagination';
import VpDeleteModal from '@vp-ui/widgets/VpMediaTable/VpDeleteModal';
import { useFetchCampaignSubmissions } from '@src/hooks';
import VpTableSkeleton from '@vp-ui/widgets/VpTableSkeleton/VpTableSkeleton';
import api from '@src/utils/api';

export const VpMediaTable = () => {
  const { data, isLoading } = useFetchCampaignSubmissions();

  const { data: giftOrdersData } = useQuery(
    ['gift-orders'],
    async () => {
      const response = await api.get('/v1/gift-orders');
      return response?.data || [];
    },
    {
      staleTime: 30000,
      refetchOnMount: true,
    }
  );

  const enrichedData = useMemo(() => {
    if (!data?.data || !giftOrdersData?.length) {
      return data;
    }

    const submissionStatusMap = {};
    giftOrdersData.forEach((order) => {
      order.items?.forEach((item) => {
        if (item.submissionId) {
          submissionStatusMap[item.submissionId] = item.status;
        }
      });
    });

    return {
      ...data,
      data: data.data.map((submission) => ({
        ...submission,
        giftOrderStatus: submissionStatusMap[submission.campaignSubmissionId] || null,
      })),
    };
  }, [data, giftOrdersData]);

  return isLoading ? (
    <VpTableSkeleton rowHeight={75} headHeight={39.5} />
  ) : (
    <TableContainer>
      <Table>
        <VpMediaTableHead />
        <VpMediaTableBody data={enrichedData} />
      </Table>
      <VpMediaTablePagination />
      <VpDeleteModal />
    </TableContainer>
  );
};



// WEBPACK FOOTER //
// ./src/vp-ui/widgets/VpMediaTable/VpMediaTable.jsx